export const colors: Colors = {
  main: "#262626",
  mainText: "#ebe0df",
  secondaryText: "String",
  background: "#1C1A19",
  activeBtn: "#F55800",
  clickBtn: "#F4F1F0",
  disabledBtn: "String",
  titleText: "#F55800",
  navBgcol: "#3E3C3C",
  menuLinks: "#d0d6d4",
};
